export const VIDEO_RATIO = 0.5625;
